import { useEffect, useRef } from 'react';

import { isEqual } from 'lodash';

import type { ChangedResponse } from 'bundles/compound-assessments/components/local-state/changed-response/types';

type AggregatorProps = {
  localScopeId: string;
  responses: ChangedResponse[];
  setLatest: (value: ChangedResponse[]) => void;
};

export const ChangedResponsesAggregator = ({ responses, setLatest, localScopeId }: AggregatorProps) => {
  const prev = useRef<{ [key: string]: ChangedResponse[] }>({});

  useEffect(() => {
    // ignore re-rendering that are caused by responses updates
    if (
      localScopeId &&
      prev.current[localScopeId] &&
      responses.length === prev.current[localScopeId].length &&
      !isEqual(responses, prev.current[localScopeId])
    ) {
      setLatest(responses);
    }
    prev.current[localScopeId] = responses;
  }, [responses, setLatest, localScopeId]);

  return null;
};
